import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "../style/App.css";

export default function OrgPicker({ afterPath = "/" }) {
  const { user, getIdTokenClaims, loginWithRedirect, isAuthenticated } = useAuth0();
  const [orgs, setOrgs] = useState([]);
  const [selectedOrgId, setSelectedOrgId] = useState("");

  // 🧠 Detect if global admin
  const isAdmin = user?.["https://til.app/claims/roles"]?.includes("admin");

  // 🔍 Load orgs from ID token (for admins & members)
  useEffect(() => {
    const loadOrgs = async () => {
      if (!isAuthenticated) return;
      try {
        const claims = await getIdTokenClaims();
        const orgsClaim = claims?.["https://til.app/claims/orgs"] || [];
        setOrgs(orgsClaim);

        // Restore or pick first org if needed
        const stored = localStorage.getItem("selectedOrgId");
        const first = orgsClaim.length === 1 ? orgsClaim[0].id : "";
        setSelectedOrgId(stored || first);


        console.log("🧭 Orgs loaded:", orgsClaim);
        console.log("🧭 Selected org:", stored || first);
      } catch (e) {
        console.error("⚠️ Error loading orgs from ID token:", e);
      }
    };
    loadOrgs();
  }, [isAuthenticated, getIdTokenClaims]);

  // 💾 Persist selection
  useEffect(() => {
    if (selectedOrgId) localStorage.setItem("selectedOrgId", selectedOrgId);
  }, [selectedOrgId]);

  // 🚪 Continue into app for normal users
  const choose = async () => {
    if (!selectedOrgId) return;
    await loginWithRedirect({
      authorizationParams: {
        organization: selectedOrgId,
        redirect_uri: window.location.origin + afterPath,
      },
    });
  };

  if (!isAuthenticated) return null;

  // 👑 If admin, show loading while skipping
  if (isAdmin) {
    return (
      <div
        className="main-content"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "var(--first-color)",
          color: "white",
        }}
      >
        <h2>👑 Admin access — loading all funds...</h2>
      </div>
    );
  }

  // 🧍 Normal user: must pick a fund
  return (
    <div
      className="main-content"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "var(--first-color)",
      }}
    >
      <div
        className="org-picker"
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          padding: "40px",
          width: "400px",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "25px" }}>Select Your Fund</h2>

        {orgs.length === 0 ? (
          <p style={{ textAlign: "center" }}>You are not currently a member of any funds.</p>
        ) : (
          <>
            <div className="form-field" style={{ marginBottom: "20px" }}>
              <label htmlFor="fundSelect" style={{ display: "block", marginBottom: "8px" }}>
                Fund
              </label>
              <select
                id="fundSelect"
                value={selectedOrgId}
                onChange={(e) => setSelectedOrgId(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid var(--third-color)",
                  borderRadius: "6px",
                }}
              >
                {orgs.map((o) => (
                  <option key={o.id} value={o.id}>
                    {o.display_name || o.name || o.id}
                  </option>
                ))}
              </select>
            </div>

            <button
              onClick={choose}
              disabled={!selectedOrgId}
              style={{
                display: "block",
                width: "100%",
                padding: "10px 0",
                backgroundColor: "var(--third-color)",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Continue
            </button>
          </>
        )}
      </div>
    </div>
  );
}
